// Shared "is this account blocked" logic — used by ProtectedRoute (to swap
// the page content for NotActiveAccount) and Navbar (to hide its own nav
// content in step with that block, instead of floating on top of it via its
// higher z-index). Keeping this in one place means the two can't drift.

// Subscription statuses that fully block access to the app, regardless of
// the signed-in user's own status.
export const BLOCKED_SUBSCRIPTION_STATUSES = ['inactive', 'suspended', 'cancelled', 'pending'];

// 'notify' is the internal super-admin company that manages every other
// company's subscription — it must never be able to lock itself out.
export const isSubscriptionBlocked = (company) =>
    company?.slug !== 'notify' && BLOCKED_SUBSCRIPTION_STATUSES.includes(company?.subscription_status);

export const isUserInactive = (userProfile) => userProfile?.status !== 'active';

// Returns 'subscription' | 'user' | null — subscription block takes
// priority since no user in a blocked company should get through, whatever
// their own status is.
export const getAccountBlockReason = ({ userProfile, company }) => {
    if (isSubscriptionBlocked(company)) return 'subscription';
    if (isUserInactive(userProfile)) return 'user';
    return null;
};
